<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard>
    <template #header>
      <ContentCardSubheader>
        {{ t('Reviews.agency.view.mediaTitle', { productName: agency.title }) }}
      </ContentCardSubheader>
    </template>

    <TabBar gap="gap-2">
      <NavTabBarItem
        :is-selected="route.meta?.tabId === ReviewsAgencySubPageRoute.Widgets"
        :to="{ name: ReviewsRouteName.ReviewsAgencyResourcesWidgetsView }"
        data-testid="reviews-resources-tab-widgets"
      >
        {{ t('Reviews.shared.media.widgets.tabLabel') }}
      </NavTabBarItem>
      <NavTabBarItem
        :is-selected="route.meta?.tabId === ReviewsAgencySubPageRoute.Badges"
        :to="{ name: ReviewsRouteName.ReviewsAgencyResourcesBadgesView }"
        data-testid="reviews-resources-tab-badges"
      >
        {{ t('Reviews.agency.view.media.badgesTabLabel') }}
      </NavTabBarItem>
    </TabBar>

    <RouterView :agency="agency" />
  </ContentCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { useReviewsAgencyBreadcrumbs } from '@/composables/breadcrumbs/useReviewsAgencyBreadcrumbs'
import type { AgencyData } from '@/gql/reviews'
import { ReviewsRouteName, ReviewsAgencySubPageRoute } from '@/router/types'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'
import { TabBar, NavTabBarItem } from '@/ui/Tabs'

const props = defineProps<{ agency: AgencyData }>()
const { t } = useI18n()
const route = useRoute()
const breadcrumbs = useReviewsAgencyBreadcrumbs(props.agency)
</script>
